document.addEventListener("DOMContentLoaded",()=>{
  document.querySelectorAll("[data-product-section]").forEach(section=>{
    const main=section.querySelector(".main-image img");
    const thumbs=[...section.querySelectorAll(".thumb")];
    let current=0;
    const show=i=>{current=(i+thumbs.length)%thumbs.length;main.src=thumbs[current].dataset.image;thumbs.forEach((t,n)=>t.classList.toggle("selected",n===current));};
    thumbs.forEach((t,i)=>t.addEventListener("click",()=>show(i)));
    section.querySelector(".gallery-arrow.left")?.addEventListener("click",()=>show(current-1));
    section.querySelector(".gallery-arrow.right")?.addEventListener("click",()=>show(current+1));

    const form=section.querySelector("[data-product-form]");
    if(!form)return;
    const variants=JSON.parse(form.querySelector("[data-variants]").textContent);
    const optionGroups=[...form.querySelectorAll(".shopify-option")];
    const selected=()=>optionGroups.map(group=>group.querySelector("[data-option-value].selected")?.dataset.optionValue);
    const update=()=>{
      const values=selected();
      const variant=variants.find(v=>v.options.every((option,i)=>option===values[i]));
      if(!variant)return;
      form.querySelector("[data-variant-id]").value=variant.id;
      const submit=form.querySelector('[type="submit"]');
      submit.disabled=!variant.available;
      submit.firstChild.textContent=variant.available?"ADD TO BAG ":"SOLD OUT ";
      const price=section.querySelector("[data-price]");
      if(price)price.textContent=window.Shopify&&Shopify.formatMoney?Shopify.formatMoney(variant.price):`${(variant.price/100).toFixed(2)}`;
    };
    optionGroups.forEach(group=>group.querySelectorAll("[data-option-value]").forEach(button=>button.addEventListener("click",()=>{
      group.querySelectorAll("[data-option-value]").forEach(b=>b.classList.remove("selected"));
      button.classList.add("selected");
      group.querySelector("[data-option-label]").textContent=button.dataset.optionValue;
      update();
    })));
    const qty=form.querySelector('input[name="quantity"]');
    form.querySelector("[data-quantity-minus]")?.addEventListener("click",()=>qty.value=Math.max(1,Number(qty.value)-1));
    form.querySelector("[data-quantity-plus]")?.addEventListener("click",()=>qty.value=Number(qty.value)+1);
  });
  document.querySelector(".menu-button")?.addEventListener("click",()=>document.querySelector(".nav-links")?.classList.toggle("mobile-open"));
});
